import SetupRmIpSmsModal from './setup-rm-ip-sms-modal.vue'
export default SetupRmIpSmsModal
